// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_progressContainer__Vy0Xi {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  min-width: 400px;
  max-width: 500px;
}

.styles_progressContent__g3M4P {
  padding: 20px;
}

.styles_progressHeader__j3boB {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.styles_progressTitle__zLzdr {
  font-weight: bold;
  font-size: 1.1rem;
}

.styles_progressBar__3AkVQ {
  margin-bottom: 8px;
}

.styles_progressInfo__clHv1 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 0.875rem;
  color: #666;
}

.styles_progressMessage__sBoJx {
  font-size: 0.75rem;
  color: #999;
  margin-top: 8px;
}

.styles_successContainer__s\\+EjM {
  display: flex;
  align-items: center;
  gap: 16px;
}

.styles_errorContainer__65Of5 {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ProgressBarFloating/styles.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX","sourcesContent":[".progressContainer {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 9999;\n  min-width: 400px;\n  max-width: 500px;\n}\n\n.progressContent {\n  padding: 20px;\n}\n\n.progressHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.progressTitle {\n  font-weight: bold;\n  font-size: 1.1rem;\n}\n\n.progressBar {\n  margin-bottom: 8px;\n}\n\n.progressInfo {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  font-size: 0.875rem;\n  color: #666;\n}\n\n.progressMessage {\n  font-size: 0.75rem;\n  color: #999;\n  margin-top: 8px;\n}\n\n.successContainer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.errorContainer {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressContainer": `styles_progressContainer__Vy0Xi`,
	"progressContent": `styles_progressContent__g3M4P`,
	"progressHeader": `styles_progressHeader__j3boB`,
	"progressTitle": `styles_progressTitle__zLzdr`,
	"progressBar": `styles_progressBar__3AkVQ`,
	"progressInfo": `styles_progressInfo__clHv1`,
	"progressMessage": `styles_progressMessage__sBoJx`,
	"successContainer": `styles_successContainer__s+EjM`,
	"errorContainer": `styles_errorContainer__65Of5`
};
export default ___CSS_LOADER_EXPORT___;
